import { header } from '../../../../web/styles/colors';
import { CssSelectors, cardStyle } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	accounting: {
		background: '#FFE5D1',
		paddingTop: 60,
	},
	architecture: {
		background: '#E8F3F9',
	},
	Chiro: {
		background: '#E8F3F9',
	},
	consulting: {
		background: '#AFDEEF',
	},
	container: {
		...cardStyle,
		alignItems: 'center',
		background: '#F7F7F7',
		border: '1px solid #F2F2F2',
		display: 'flex',
		height: 200,
		justifyContent: 'center',
		position: 'relative',
		width: 300,
	},
	Dental: {
		background: '#F0FBE6',
	},
	Health: {
		background: '#E6F5F3',
	},
	eng: {
		background: '#FFE5D1',
	},
	fin: {
		background: '#F0FBE6',
	},
	ins: {
		background: '#E8F3F9',
	},
	label: {
		color: header,
		fontSize: 32,
		fontWeight: 600,
		left: 28,
		position: 'absolute',
		textTransform: 'uppercase',
		top: 22,
	},
	legal: {
		background: '#FEF8DA',
	},
	lev: {
		background: '#AFDEEF',
	},
	nonprofit: {
		background: '#F9F3F7',
		paddingTop: 40,
	},
	others: {
		...CssSelectors.allChildren(
			{
				marginLeft: 100,
			},
			'.svg-icon'
		),
	},
	re: {
		background: '#F9F3F7',
	},
});
